import { useMemo } from 'react'

import { useBookACallRecommendation } from '../modules/BookACallRecommendation'
import { useJoinDiscordRecommendation } from '../modules/JoinDiscordRecommendation'
import { useLaunchStrategyRecommendation } from '../modules/LaunchStrategyRecommendation'
import { useVisitHelpCenterRecommendation } from '../modules/VisitHelpCenterRecommendation'

export const useHelpRecommendations = () => {
  const { bookACallRecommendation } = useBookACallRecommendation()
  const { visitHelpCenterRecommendation } = useVisitHelpCenterRecommendation()
  const { joinDiscordRecommendation } = useJoinDiscordRecommendation()
  const { launchStrategyRecommendation } = useLaunchStrategyRecommendation()

  const helpRecommendations = useMemo(() => {
    return [
      bookACallRecommendation,
      visitHelpCenterRecommendation,
      joinDiscordRecommendation,
      launchStrategyRecommendation,
    ].filter(({ enabled }) => enabled)
  }, [
    bookACallRecommendation,
    joinDiscordRecommendation,
    launchStrategyRecommendation,
    visitHelpCenterRecommendation,
  ])

  return {
    helpRecommendations,
  }
}
